import clsx from "clsx";
import React from "react";
import { useTheme } from "../../hooks/useTheme";
import { AlertConstants } from "../../types";
import { Icon } from "../icon";
import { StyledAlert } from "./AlertStyles";
const Alert = ({ type, className = "", children, id, onRemove, styles = {}, }) => {
    const { Theme } = useTheme();
    const StylesOverride = { ...Theme.alert, ...styles };
    const DangerTheme = StylesOverride["danger"];
    const SuccessTheme = StylesOverride["success"];
    const WarningTheme = StylesOverride["warning"];
    const InfoTheme = StylesOverride["info"];
    const getTheme = (theme) => {
        const themeStr = !!theme ? theme.toLowerCase() : "";
        switch (themeStr) {
            case AlertConstants.TYPES.DANGER:
                return DangerTheme;
            case AlertConstants.TYPES.WARNING:
                return WarningTheme;
            case AlertConstants.TYPES.INFO:
                return InfoTheme;
            case AlertConstants.TYPES.SUCCESS:
            default:
                return SuccessTheme;
        }
    };
    const removeAlert = () => {
        if (onRemove && !!id) {
            onRemove(id);
        }
    };
    const theme = getTheme(type);
    return (React.createElement(StyledAlert, { type: theme, styles: StylesOverride, className: clsx("best-alert", className) },
        React.createElement("div", { className: "d-flex justify-content-between" },
            React.createElement("div", { className: "d-flex flex-wrap w-100 h-100" }, children),
            !!onRemove && (React.createElement(Icon, { className: "ps-2", iconName: "fa-times-circle", styles: { color: theme.color }, onClick: removeAlert })))));
};
export default Alert;
//# sourceMappingURL=Alert.js.map